import React, {
  Dispatch,
  SetStateAction,
  useEffect,
  useRef,
  useState
} from 'react'
import * as BPTLButtonStyles from './BPTLButton.module.scss'
import Popup from './Popup'

interface IBPTLButton {
  post: any
  popupVisible: boolean
  setPopup: Dispatch<SetStateAction<string | undefined>>
  siteId: number | null
  catName: string
}

const BPTLButton = ({
  post,
  popupVisible,
  setPopup,
  siteId,
  catName
}: IBPTLButton) => {
  const [showPopup, setShowPopup] = useState<boolean>(popupVisible)
  const btn = useRef(null)

  const handleVote = (event: React.MouseEvent<HTMLDivElement>) => {
    if (event.target === btn.current) {
      setShowPopup(true)
      setPopup(post.id)
    }
  }

  useEffect(() => {
    setShowPopup(popupVisible)
  }, [popupVisible])

  return (
    <>
      <div ref={btn} className={BPTLButtonStyles.Button} onClick={handleVote}>
        Vote for {post.title.replace('Best Places to Live:', '')}
      </div>
      {showPopup && (
        <Popup
          catName={catName}
          siteId={siteId}
          post={post}
          setShowPopup={setPopup}
        />
      )}
    </>
  )
}

export default BPTLButton
